import React, { useState, ReactNode } from 'react';
import { ManagerContext } from './index';

interface Props {
  children: ReactNode;
}

export const ManagerProvider: React.FC<Props> = ({ children }) => {
  const [isReadOnly, setIsReadOnly] = useState(false);

  const grantManager = (isReadOnly: boolean) => {
    setIsReadOnly(isReadOnly);
  };

  const revokeManager = () => {
    setIsReadOnly(true);
  };

  return (
    <ManagerContext.Provider
      value={{ isReadOnly, grantManager, revokeManager }}
    >
      {children}
    </ManagerContext.Provider>
  );
};
